import { render } from "./member-events.vue?vue&type=template&id=625d3fd8"
import script from "./member-events.vue?vue&type=script&lang=js"
export * from "./member-events.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__